import React from 'react';
import PropTypes from 'prop-types';
import './featured-icon.scss';
import clsx from 'clsx';
import Icon, { IconColors, IconSizes } from '../icon';
import { FeaturedIconColors, FeaturedIconSizes } from './featured-icon-dictionary';

const IconColorMapping = {
  [FeaturedIconColors.DARK]: IconColors.DARK,
  [FeaturedIconColors.PRIMARY]: IconColors.PRIMARY,
  [FeaturedIconColors.ERROR]: IconColors.ERROR,
  [FeaturedIconColors.WARNING]: IconColors.WARNING,
  [FeaturedIconColors.SUCCESS]: IconColors.SUCCESS,
  [FeaturedIconColors.BLUE]: IconColors.BLUE,
};

const IconSizeMapping = {
  [FeaturedIconSizes.X_SMALL]: IconSizes.X_SMALL,
  [FeaturedIconSizes.SMALL]: IconSizes.SMALL,
  [FeaturedIconSizes.MEDIUM]: IconSizes.MEDIUM,
  [FeaturedIconSizes.LARGE]: IconSizes.LARGE,
  [FeaturedIconSizes.X_LARGE]: IconSizes.X_LARGE,
};

const FeaturedIcon = React.forwardRef(({
  type, size, color, className, onClick, renderIcon,
}, ref) => {
  const classNames = clsx('featured-icon-cont', color, size, className);

  const handleOnClick = () => {
    if (onClick && typeof onClick === 'function') {
      onClick.call(null);
    }
  };

  // Change Icon here
  return (
    <div className={classNames} onClick={handleOnClick} ref={ref}>
      {
        renderIcon ? renderIcon({ size, color }) : (
          <Icon
            icon={type}
            size={IconSizeMapping[size]}
            color={IconColorMapping[color]}
          />
        )
      }
    </div>
  );
});

FeaturedIcon.propTypes = {
  type: PropTypes.oneOfType([PropTypes.element,
    PropTypes.elementType, PropTypes.func, PropTypes.oneOf([null])]),
  size: PropTypes.oneOf(Object.values(FeaturedIconSizes)),
  color: PropTypes.oneOf(Object.values(FeaturedIconColors)),
  className: PropTypes.string,
  onClick: PropTypes.func,
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf([null])]),
};

FeaturedIcon.defaultProps = {
  type: null,
  size: FeaturedIconSizes.LARGE,
  color: FeaturedIconColors.DARK,
  className: '',
  onClick: null,
  renderIcon: null,
};

export {
  FeaturedIcon as default,
  FeaturedIconColors,
  FeaturedIconSizes,
};
